import {
  eaptekaApi,
  responseHandler
} from '../../eaptekaApi';

export const eaptekaApiRequestPromocodePost =
  eaptekaApi.createPostMethod('/cart/promocode', {
    mapRequest: (params) => ({
      body: JSON.stringify(params)
    }),
    mapResponse: (response) => responseHandler(response)
  });
